var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainwrap"},[_c('el-container',[_c('i',{staticClass:"switchbar",class:{ active: !_vm.flag },on:{"click":_vm.check}}),_c('div',{staticClass:"forsidebar",class:{ active: _vm.flag }},[_c('Aside')],1),_c('el-container',[_c('div',{staticClass:"main"},[_c('Heading'),_c('router-view',{key:_vm.$route.fullPath})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }